import { ErrorMessage } from "formik";

interface InputErrorsComponentProps {
  inputName: string;
}

const InputErrorsComponent = ({ inputName }: InputErrorsComponentProps) => {
  return (
    <ErrorMessage component="" name={inputName}>
      {(msg) => (
        <p className="!-mt-4 !mb-4 flex text-danger-tint !text-sm">{msg}</p>
      )}
    </ErrorMessage>
  );
};

export default InputErrorsComponent;
